import { render, staticRenderFns } from "./MpBonusStage.vue?vue&type=template&id=5838dd01&scoped=true&"
import script from "./MpBonusStage.vue?vue&type=script&lang=js&"
export * from "./MpBonusStage.vue?vue&type=script&lang=js&"
import style0 from "./MpBonusStage.vue?vue&type=style&index=0&id=5838dd01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838dd01",
  null
  
)

export default component.exports